var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirclePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.1094C0.5 5.69606 5.69606 0.5 12.1094 0.5C18.5227 0.5 23.7188 5.69606 23.7188 12.1094C23.7188 18.5227 18.5227 23.7188 12.1094 23.7188C5.69606 23.7188 0.5 18.5227 0.5 12.1094ZM18.5547 14.5625C19.1531 14.5625 19.6406 14.075 19.6406 13.4766V10.7422C19.6406 10.1438 19.1531 9.65625 18.5547 9.65625H14.5625V5.66406C14.5625 5.06565 14.075 4.57812 13.4766 4.57812H10.7422C10.1438 4.57812 9.65625 5.06565 9.65625 5.66406V9.65625H5.66406C5.06565 9.65625 4.57812 10.1438 4.57812 10.7422V13.4766C4.57812 14.075 5.06565 14.5625 5.66406 14.5625H9.65625V18.5547C9.65625 19.1531 10.1438 19.6406 10.7422 19.6406H13.4766C14.075 19.6406 14.5625 19.1531 14.5625 18.5547V14.5625H18.5547Z",
    fill: "black",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle-plus.2942fdf2bb8fba1fc266e54531f2aa65.svg";
export { ForwardRef as ReactComponent };